export default __webpack_public_path__ + "static/media/gallery - handwriting style_00.98c6dd83.jpg";